module.exports = __webpack_public_path__ + "img/marina.cdd6ca0e.jpg";